import { Box, Chip, Typography } from '@mui/material';
import type React from 'react';
import { type Column, StandardTable } from '../../common/UI/StandardTable';
import type { ActivityData } from './types';

interface UsersTabProps {
  data: ActivityData;
  getUserLabel: (userId?: string) => string;
  formatTimestamp: (timestamp: string) => string;
}

export const UsersTab: React.FC<UsersTabProps> = ({ data, getUserLabel, formatTimestamp }) => {
  if (!data.topUsers) {
    return null;
  }

  const columns: Column<NonNullable<ActivityData['topUsers']>[number]>[] = [
    {
      id: 'user',
      label: 'User',
      render: (userActivity) => getUserLabel(userActivity.userId),
    },
    {
      id: 'role',
      label: 'Role',
      render: (userActivity) => <Chip label={userActivity.userRole} size="small" color="default" />,
    },
    {
      id: 'activityCount',
      label: 'Activity Count',
      align: 'right',
      render: (userActivity) => userActivity.activityCount,
    },
    {
      id: 'lastActivity',
      label: 'Last Activity',
      render: (userActivity) => formatTimestamp(userActivity.lastActivity),
    },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom sx={{ pl: 2 }}>
        Most Active Users
      </Typography>
      <StandardTable
        columns={columns}
        data={data.topUsers}
        keyExtractor={(userActivity) => userActivity.userId}
      />
    </Box>
  );
};
